import { heroStats } from "@/mocks/homeContent";

export default function Hero({ onOpenSearch }: { onOpenSearch: () => void }) {
  return (
    <section id="top" className="relative flex min-h-[92vh] flex-col overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center object-top"
        style={{
          backgroundImage:
            "url(https://readdy.ai/api/search-image?query=Moody%20editorial%20collage%20of%20magazine%20covers%20and%20stage%20spotlights%20and%20film%20screens%20in%20deep%20charcoal%20space%2C%20crimson%20red%20and%20warm%20amber%20glow%2C%20abstract%20entertainment%20newsroom%20aesthetic%2C%20high%20contrast%2C%20dark%20and%20cinematic%2C%20premium%20tabloid%20editorial%20style&width=1600&height=900&seq=hero-mrhl&orientation=landscape)",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-black/80"></div>

      <div className="relative z-10 container-page flex flex-1 flex-col items-center justify-center py-24 text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-primary-500/90 px-4 py-1.5 text-xs md:text-sm font-medium text-background-50">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-white opacity-75"></span>
            <span className="relative inline-flex h-2 w-2 rounded-full bg-white"></span>
          </span>
          今日热榜已更新 · 09-09 精选 8 条
        </span>

        <h1 className="mt-6 max-w-4xl font-heading text-4xl font-black leading-tight tracking-tight text-background-50 md:text-6xl">
          全网热点，
          <br className="md:hidden" />
          一条条<b className="text-accent-400">扒</b>给你看
        </h1>
        <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-100/85 md:text-lg">
          每日黑料深扒栏目，把热度高、讨论多的娱乐与舆论话题，从源头到关键节点逐条补齐时间线。
          想看最新最全的热点汇总、深扒精选与专题合集，进这一个页面就能找到。
        </p>

        {/* search trigger */}
        <div className="mt-8 flex w-full max-w-xl flex-col items-stretch gap-2 sm:flex-row sm:items-center">
          <div className="flex flex-1 items-center gap-3 rounded-full bg-background-50/95 px-5 py-3 ring-1 ring-background-50/40">
            <i className="ri-search-line text-lg text-primary-500"></i>
            <input
              readOnly
              onFocus={onOpenSearch}
              placeholder="想搜哪条热点？试试「名场面」「考古」「营销」"
              className="w-full bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
            />
          </div>
          <button
            onClick={onOpenSearch}
            className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            搜索热点
          </button>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <a
            href="#hot"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-6 py-3 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-600"
          >
            开始浏览热榜
            <i className="ri-arrow-down-line"></i>
          </a>
          <a
            href="#about"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50/10 px-6 py-3 text-sm font-medium text-background-50 ring-1 ring-background-50/30 transition-colors hover:bg-background-50/20"
          >
            了解本站
          </a>
        </div>

        {/* stats */}
        <dl className="mt-14 grid w-full max-w-3xl grid-cols-2 gap-y-8 sm:grid-cols-4">
          {heroStats.map((s) => (
            <div key={s.label} className="flex flex-col items-center gap-1">
              <dt className="sr-only">{s.label}</dt>
              <dd className="font-heading text-2xl md:text-3xl font-bold text-background-50">{s.num}</dd>
              <dd className="text-xs text-background-200/70 md:text-sm">{s.label}</dd>
            </div>
          ))}
        </dl>
      </div>

      <a
        href="#hot"
        aria-label="向下浏览"
        className="absolute bottom-6 left-1/2 z-10 flex h-10 w-10 -translate-x-1/2 items-center justify-center rounded-full bg-background-50/10 text-background-50 ring-1 ring-background-50/30 hover:bg-background-50/20"
      >
        <i className="ri-arrow-down-s-line text-xl"></i>
      </a>
    </section>
  );
}